// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aI2Il","paginator":"styles_paginator__3JSJ7"};